import { render, staticRenderFns } from "./vRestriccionPostulante.vue?vue&type=template&id=23050e1b&scoped=true&"
import script from "./vRestriccionPostulante.vue?vue&type=script&lang=js&"
export * from "./vRestriccionPostulante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23050e1b",
  null
  
)

export default component.exports